//
//
//
//
//
//
//
//
//
//
import Pay from '../pay/pay.vue';
import Reward from '../reward/reward.vue';
import GiftFriend from '../gift-friend/gift-friend.vue';
export default {
  components: {
    Pay: Pay,
    Reward: Reward,
    GiftFriend: GiftFriend
  },
  mounted: function mounted() {
    var _this = this;

    // 滚动到抽奖模块
    this.eventBus.$on('scrollToNewYeay', function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var el = _this.$refs.newYear;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top;

      window.scroll({
        left: 0,
        top: scrollTop + top
      });
    });
  }
};